import React from 'react';
import { renderRoutes, RouteConfigComponentProps } from 'react-router-config';

const StaffAssignments: React.FC<RouteConfigComponentProps> = ({ route }) => renderRoutes(route?.routes);

export default StaffAssignments;
